import { useQuery } from '@tanstack/react-query';
import { getDocumentsV2 } from 'utils/DocumentsAPIUtils';
// The POD document is foreign-keyed to the shipment id (matches ShipmentDetails).
async function fetchPodKey(shipmentId) {
    var _a, _b, _c, _d, _e;
    try {
        const result = await getDocumentsV2([shipmentId], {
            types: 'proof_of_delivery',
            options: {
                order: { field: 'createdAt', direction: 'desc' },
                limit: 1,
            },
        });
        return ((_e = (_d = (_c = (_b = (_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.getDocumentsV2) === null || _b === void 0 ? void 0 : _b.documents) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.key) !== null && _e !== void 0 ? _e : null);
    }
    catch (e) {
        console.error('useShipmentPods: failed to fetch POD', e);
        return null;
    }
}
export function useShipmentPods(shipmentIds, options = {}) {
    var _a, _b;
    const ids = [...new Set(shipmentIds.filter(Boolean))].sort();
    return useQuery({
        queryKey: ['shipment-pods', ids],
        queryFn: async () => {
            const entries = await Promise.all(ids.map(async (id) => [
                id,
                await fetchPodKey(id),
            ]));
            return Object.fromEntries(entries);
        },
        enabled: ((_a = options.enabled) !== null && _a !== void 0 ? _a : true) && ids.length > 0,
        staleTime: (_b = options.staleTime) !== null && _b !== void 0 ? _b : 30000,
    });
}
